<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <div v-if="state==='welcome'" class="welcomeRect">
      <img src="/img/third/cooldive202201/welcome.jpg">
      <div class="buttonRect" @click="onInfo" />
    </div>
    <div v-if="state==='info'" class="infoRect">
      <img src="/img/third/cooldive202201/info_back.jpg">
      <template v-if="data">
        <div class="cardRect">
          <div class="cardImg">
            <img :src="data.cardImg?data.cardImg:'/img/defaultcertificate.jpg'">
          </div>
        </div>
        <template v-if="data.isFreeCertificate || data.isMermaidCertificate">
          <div class="infoLine" style="top: 90vw;">
            <van-row>
              <van-col span="10" class="font_right">潜水组织:</van-col>
              <van-col span="14">{{ data.cerificateName }}</van-col>
            </van-row>
          </div>
          <div class="infoLine" style="top: 102vw;">
            <van-row>
              <van-col span="10" class="font_right">姓名:</van-col>
              <van-col span="14">{{ data.userName }}</van-col>
            </van-row>
          </div>
          <div class="infoLine" style="top: 114vw;">
            <van-row>
              <van-col span="10" class="font_right">生日:</van-col>
              <van-col span="14">{{ formatDate(data.birthday,'yyyy.MM.dd') }}</van-col>
            </van-row>
          </div>
          <div class="infoLine" style="top: 126vw;">
            <van-row>
              <van-col span="10" class="font_right">手机号码:</van-col>
              <van-col span="14">{{ data.phoneHide }}</van-col>
            </van-row>
          </div>
          <div class="buttonRect" style="top: 138vw;">
            <img src="/img/third/cooldive202201/button.png" @click="onPaper">
            <div v-if="data.memberCardId" class="memberCardLine" @click="onMemberCard">查看奖品</div>
          </div>
        </template>
        <template v-if="!data.isFreeCertificate && !data.isMermaidCertificate">
          <div class="infoLine" style="top: 90vw;">
            <van-row>
              <van-col span="10" class="font_right">潜水组织:</van-col>
              <van-col span="14">{{ data.isChecking?'查询中,请稍等!':'请先查询潜水证书' }}</van-col>
            </van-row>
          </div>
          <div class="buttonRect" style="top: 102vw;">
            <img src="/img/third/cooldive202201/buttonser.png" @click="onSer">
          </div>

        </template>
      </template>
    </div>
    <div v-if="state==='paper'" class="papaerRect">
      <img :src="papaerUrl">
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Toast, Button } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetServiceUrlBase } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '围捕美人鱼',
      backurl: '/store/index',
      state: 'welcome',
      recvId: undefined,
      data: undefined,
      papaerUrl: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.recvId = getUrlKey('e')
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onBack() {
      switch (this.state) {
        case 'welcome':
          this.$router.push('/store/index')
          break
        case 'info':
          this.state = 'welcome'
          break
        case 'paper':
          this.onInfo()
          break
      }
    },
    init() {
      request({
        url: '/Activity/checkLogin',
        method: 'post'
      }).then(response => {
      })
    },
    mermaidInfo() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      request({
        url: '/Activity/getMermaidGetInfo',
        method: 'get',
        params: { id: this.recvId }
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        this.data = response.data
        console.log('getMermaidGetInfo', response.data)
      })
    },
    onInfo() {
      this.state = 'info'
      this.mermaidInfo()
    },
    onPaper() {
      this.papaerUrl = undefined
      setTimeout(() => {
        this.papaerUrl = GetServiceUrlBase() + '/userAPI/Activity/getMermaidGetPaper?id=' + this.data.userId
      }, 1)
      this.state = 'paper'
    },
    onSer() {
      this.$router.push('/my/myCerificate')
    },
    onMemberCard() {
      this.$router.push('/memberCard/memberCardList')
    }
  }
}
</script>
<style scoped>
.welcomeRect{
  position: relative;
  width: 100%;
  overflow: hidden;
}
.welcomeRect img{
  width: 100%;
}
.welcomeRect .buttonRect{
  position: absolute;
  left: 20vw;
  width: 60vw;
  height: 40vw;
  bottom: 0;
}
.papaerRect{
  position: relative;
  width: 100%;
  overflow: hidden;
}
.papaerRect img{
  width: 100%;
}
.infoRect{
  width: 100%;
  position: relative;
  overflow: hidden;
}
.infoRect img{
  width: 100%;
}
.infoRect .buttonRect{
  position: absolute;
  width: 80vw;
  left: 10vw;
}
.infoRect .buttonRect .memberCardLine{
  text-align: center;
  color: #fff;
  font-size: 0.9em;
}
.infoRect .cardRect{
  position: absolute;
  width: 84vw;
  left: 8vw;
  top: 18vw;
  height: 64vw;
  border-radius: 0.5em;
  box-shadow: 0px 0px 10px #333;
}
.infoRect .cardRect .cardImg{
  width: 68vw;
  margin-left: 8vw;
  margin-top:15vw;
  border-radius: 0.5em;
  overflow: hidden;
}
.infoRect .cardRect .cardImg img{
  width: 100%;
  border-radius: 0.5em;
}
.infoRect .infoLine{
  letter-spacing:3px;
  font-size: 1.1em;
  font-weight: 700;
  line-height: 8vw;
  color: #fff;
  position: absolute;
  top: 90vw;
  left: 8vw;
  height: 8vw;
  width: 84vw;
  border-radius: 0.5em;
  border: 1px solid #fff;
  box-shadow: 0px 0px 10px #333;
}
.font_right{
  text-align: right;
}
</style>
